import dayjs, { Dayjs } from 'dayjs';

export const SLOT_DATETIME_FORMAT = 'ddd, MMM D, h:mm A';
export const SLOT_END_TIME_FORMAT = 'h:mm A';

export function timezoneAbbrevForDate(date: Date): string {
  return (
    new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
      .formatToParts(date)
      .find((part) => part.type === 'timeZoneName')?.value ?? ''
  );
}

export function formatSlotLabel(startsAt: string, durationMinutes: number): string {
  const start = dayjs(startsAt);
  const end = start.add(durationMinutes, 'minute');
  const range = `${start.format(SLOT_DATETIME_FORMAT)} – ${end.format(SLOT_END_TIME_FORMAT)}`;
  const tzAbbr = timezoneAbbrevForDate(start.toDate());
  return tzAbbr ? `${range} ${tzAbbr}` : range;
}

export function formatSlotLabelFromDayjs(when: Dayjs, durationMinutes: number): string {
  return formatSlotLabel(when.toISOString(), durationMinutes);
}
